import _ from 'lodash'
import React, { Component } from 'react';
import { Container, Header, Button, Icon, Divider, Image, Grid, Popup } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import {YouTubeLinks} from './info/YouTubeLinks.js';
import axios from 'axios';

import {summaries} from './info/summaries.js';
import {categories} from './info/categories.js';
import { FeaturedVideos } from './Helpers.js';
import { API_URL, WEB_URL } from '../App.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import ReactGA from "react-ga4";
import { customFontFam3, customTitleFontFam3, customFirefoxTitleFontFam } from './constants/constants.js';
import ReCAPTCHA from "react-google-recaptcha";

ReactGA.initialize("G-JZB9CXH4GJ")
// const categories = _.times(6, (i) => (
//   <Grid.Column key={i}>
//   	<div>
// 	    <Image src='/images/categories1.jpg' />
// 	    <h3 className='yugtun'>Ellavut</h3>
// 	    Weather, Climate
// 	  </div>
//   </Grid.Column>
// ))

// const keywords = _.times(6, (i) => (
//   <Grid.Column key={i}>
//   	<Button basic color='blue' size='mini'>Yugtun<br /><em>inYup'ik</em></Button>
//   </Grid.Column>
// ))

let customFontFam = customFontFam3
let customTitleFontFam = customTitleFontFam3
let customFontFam2 = {fontFamily:customTitleFontFam3}
let letterbutton = {fontFamily:customFontFam3,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px',fontSize:'16px'}
const isFirefox = typeof InstallTrigger !== 'undefined';

if (isFirefox) {
  customFontFam = customFirefoxTitleFontFam
  customTitleFontFam = customFirefoxTitleFontFam
  customFontFam2 = {fontFamily:customFirefoxTitleFontFam}
  letterbutton = {fontFamily:customFirefoxTitleFontFam,paddingTop:'10px',paddingBottom:'10px',paddingRight:'14px',paddingLeft:'14px',fontSize:'16px'}
}

let manualPictures = [
	'7ud0NmMhtNg',
	'0XP2AUXNbDE',
	'UNjQYpplVAk',
	'6aJ1rS0v9AY',
]

class Home extends Component {
	constructor(props) {
		super(props);
		this.state = {
			show: false,
			showAllElders: false,
			categoriesDisplayed: ['1','2','3','4','5','6'],
			featuredVideoIDs:['F_bWrmqQB74','3TIkchKpXqY','XcMTNy-xdF4','np1a4SIbzKg',],
			featuredVideoIDs2:['7ud0NmMhtNg','E6h9Cryzk3M','0XP2AUXNbDE','UNjQYpplVAk','6aJ1rS0v9AY'],
			featuredZooms:['sS4vCvvOj8M','r78afbyVauw','kGCA7_Gc2ys','UbhmhRJClhg','NaYBwnGnA_0','tNLboGKVYhY'],
			// eldersList: [],
			showMoreVideos:false,
			recaptchaAllowed:false,
			reloadingData:false,
			finishedReload:false
		}
	}

	// componentDidMount() {
	// 	let eldersList = []
	// 	Object.keys(categories).map((k) => {
	// 		if (k.includes('23.')) {
	// 			eldersList.push(k)
	// 		}
	// 	})
	// 	this.setState({eldersList:eldersList})
	// }

  // reloadKingikData = () => {
  // 		this.setState({reloadingData:true})
  //     axios
  //     .get(API_URL + "/reloadKingikDataDownload")
  //     .then(response => {
  //       this.setState({reloadingData:false,finishedReload:true})
  //       console.log(response.data);
  //     });
  //   }


	render() {
		console.log(this.props)
		let showLargerTable = window.innerWidth >= 480
		return (
			<div className='home'>
				{showLargerTable ?
					<LazyLoadImage effect='opacity' width={'100%'} style={{borderRadius:'10px',marginBottom:10}} src={'/resourcesbanner2.png'} />				
					:
					null
				}
				<div className='yugtatun'>Kiŋikmiutun Table</div>
				<div className='yugtatunsub'>Wales Dialect Terms with Richard Atuk Phonetic System</div>


				<div style={{display:'flex',justifyContent:'center',flexDirection:'row',flexWrap:'wrap',maxWidth:'820px',marginLeft:'auto',marginRight:'auto'}}>
					<div className='categoryButton' style={{margin:'20px'}}>
				  	<Link to={{pathname: '/search/'}}>
				  		<div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',backgroundColor:'white',color:'black',padding:'20px',maxWidth:'60%',opacity:'90%',borderRadius:'10px'}}>
					    	<div style={{fontWeight:'bold'}}>{'Kiŋikmiutun Table'}</div>
					    	<div>{'Richard Atuk Phonetic System'}</div>
					    </div>
					    <LazyLoadImage effect='opacity' width={'300px'} height={'200px'} style={{borderRadius:'10px'}} src={'siuexample.png'} />
					  </Link>
					</div>
				</div>


				<Divider />


				<div className='yugtatun'>Kiŋikmiut Videos with Transcription</div>
				<div className='yugtatunsub'>Featured Videos</div>


					<div style={{display:'flex',justifyContent:'center',flexDirection:'row',flexWrap:'wrap',maxWidth:'820px',marginLeft:'auto',marginRight:'auto'}}>
						{this.state.featuredVideoIDs.map((j) => (
							j in this.props.videoList ?
							<div className='categoryButton' style={{margin:'20px'}}>
						  	<Link to={{pathname: '/video/'+j}}>
						  		<div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',backgroundColor:'white',color:'black',padding:'20px',maxWidth:'60%',opacity:'90%',borderRadius:'10px'}}>
							    	<div style={{fontWeight:'bold'}}>{this.props.videoList[j]['title']}</div>
							    	<div>{this.props.videoList[j]['category']}</div>
							    </div>
							    {/*<Image style={{borderRadius:'10px'}} src={'https://img.youtube.com/vi/'+y+'/sddefault.jpg'} />*/}
							    <LazyLoadImage effect='opacity' width={'310px'} height={'190px'} style={{borderRadius:'10px'}} src={(manualPictures.includes(j) ? j+'.png' : 'https://img.youtube.com/vi/'+j+'/maxresdefault.jpg')} />
							  </Link>
							</div>
							:
							null
						))}




				{this.state.showMoreVideos ?
					Object.keys(this.props.videoList).map((j) => (
						this.props.videoList[j]['category'] != 'Zoom Session' && !(this.state.featuredVideoIDs.includes(j)) ?
						<div className='categoryButton' style={{margin:'20px'}}>
					  	<Link to={{pathname: '/video/'+j}}>
					  		<div style={{position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',backgroundColor:'white',color:'black',padding:'20px',maxWidth:'60%',opacity:'90%',borderRadius:'10px'}}>
						    	<div style={{fontWeight:'bold'}}>{this.props.videoList[j]['title']}</div>
						    	<div>{this.props.videoList[j]['category']}</div>
						    </div>
						    {/*<Image style={{borderRadius:'10px'}} src={'https://img.youtube.com/vi/'+y+'/sddefault.jpg'} />*/}
						    <LazyLoadImage effect='opacity' width={'310px'} height={'190px'} style={{borderRadius:'10px'}} src={(manualPictures.includes(j) ? j+'.png' : 'https://img.youtube.com/vi/'+j+'/maxresdefault.jpg')} />
						  </Link>
						</div>
						:
						null
					))
					:
					<div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',margin:'24px'}}>
			        <Button basic style={{fontSize:16,display:'flex',flexDirection:'row',alignItems:'center'}} onClick={()=>{this.setState({showMoreVideos:true})}}>
			          <span style={{fontSize:16,lineHeight:'20px',marginRight:'10px'}}>{"See More Videos"}</span>
			          <Icon style={{float:'right',fontSize:16}} name='chevron down' />
			        </Button>	
	        </div>
	      }

					</div>
					

				<Divider style={{marginTop:'24px'}} />


				<div className='yugtatun'>Inupiaraaqta Zoom Sessions</div>
				<div className='yugtatunsub'>Featured Sessions</div>

			    <Grid textAlign='center'>
			      <Grid.Row style={{paddingTop:0}}>
			        <Grid.Column style={{  maxWidth: 860, padding: 0, fontFamily:customFontFam }} textAlign='left'>
			          <div style={{display:'flex',flexWrap:'wrap',fontSize:'16px',justifyContent:'center'}}>
		          		{this.state.featuredZooms.map((y,yindex)=>
		          			(y in this.props.videoList ?
			              (showLargerTable ? 
			                <div style={{width:"200px",margin:'15px',marginTop:'25px'}}>
			                  <Link to={{pathname: '/video/'+y}}>
			                    <Image style={{borderRadius:'10px'}} src={'https://img.youtube.com/vi/'+y+'/sddefault.jpg'} />
			                    {/*<div style={{color:'#000000DE',fontWeight:'600'}}>{'Inupiaraaqta Zoom'}</div>*/}
			                  </Link>
			                  <div style={{color:'#000000DE',fontWeight:'600',fontSize:'16px',marginTop:'5px',marginBottom:'3px'}}>{this.props.videoList[y].date}</div>
			                  <div style={{fontSize:'14px',lineHeight:'16px',color:'#00000099'}}>{this.props.videoList[y]['summary']}</div>
			                </div>
			                :
			                <Grid style={{marginTop:'20px'}}>
			                  <Grid.Row columns={2} style={{alignItems:'center',margin:'3px 10px'}}>
			                    <Grid.Column width={7}>
			                    <Link to={{pathname: '/video/'+y}}>
			                      <Image style={{borderRadius:'10px'}} src={'https://img.youtube.com/vi/'+y+'/sddefault.jpg'} />
			                      {/*<div style={{color:'#000000DE',fontWeight:'600'}}>{'Inupiaraaqta Zoom'}</div>*/}
			                    </Link>
			                    </Grid.Column>
			                    <Grid.Column width={9}>
			                    <div style={{color:'#000000DE',fontWeight:'600',fontSize:'16px',marginTop:'5px',marginBottom:'3px'}}>{this.props.videoList[y].date}</div>
			                    <div style={{fontSize:'14px',lineHeight:'16px',color:'#00000099'}}>{this.props.videoList[y]['summary']}</div>
			                    </Grid.Column>
			                  </Grid.Row>
			                </Grid>
			              )
			              :
			              null
			              )
		                )}
		               </div>
	                </Grid.Column>
	              </Grid.Row>
	            </Grid>

			    <Grid textAlign='center'>
			      <Grid.Row columns={2} style={{maxWidth: 600, paddingTop:0}}>
			        <Grid.Column width={8} style={{padding: 0, fontFamily:customFontFam }} textAlign='left'>	            
						<div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',margin:'24px'}}>
							<Link to={{pathname: '/zoomlist/'}}>
						        <Button basic style={{fontSize:16,display:'flex',flexDirection:'row',alignItems:'center'}}>
						          <span style={{fontSize:16,lineHeight:'20px'}}>{"Browse All Sessions"}</span>
						          <Icon style={{float:'right',fontSize:16}} name='chevron right' />
						        </Button>			        
					        </Link>
		        		</div>
		        	</Grid.Column>
		        	<Grid.Column width={8} >
						<div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',margin:'24px'}}>
							<Link to={{pathname: '/zoomsearch/'}}>
						        <Button basic style={{fontSize:16,display:'flex',flexDirection:'row',alignItems:'center'}}>
						          <span style={{fontSize:16,lineHeight:'20px'}}>{"Search Transcripts"}</span>
						          <Icon style={{float:'right',fontSize:16}} name='chevron right' />
						        </Button>			        
					        </Link>
		        		</div>
	                </Grid.Column>
	              </Grid.Row>
	            </Grid>

				<Divider style={{marginTop:'24px'}} />
{/*						<div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column',margin:'24px'}}>
							<Link to={{pathname: '/recorder/'}}>
						        <Button basic style={{fontSize:16,display:'flex',flexDirection:'row',alignItems:'center'}}>
						          <span style={{fontSize:16,lineHeight:'20px'}}>{"Recording Tools"}</span>
						          <Icon style={{float:'right',fontSize:16}} name='chevron right' />
						        </Button>			        
					        </Link>
					      </div>*/}

				<div style={{display:'flex',justifyContent:'center',textAlign:'center',marginTop:'30px',marginBottom:'20px'}}>

					<div style={{paddingTop:'10px',paddingBottom:'30px',paddingLeft:'8px'}}>
			    <Link to={{pathname: '/report'}}>
						<Icon style={{color:'#a9a9a9',}} name='exclamation circle' />
						<span style={{fontSize:'14px',color:'#9d9d9d',fontWeight:'400',lineHeight:'23px'}}>Report an Issue</span>
          </Link>

          <Popup hideOnScroll on='click' position={'bottom'} content={
            <div style={{fontFamily:customFontFam,textAlign:'center'}}>
							<ReCAPTCHA
								  style={{margin:5}}
							    sitekey="6LcjLeMrAAAAAAc3X2tUrlQ66G9H7X2DImvTK7B6"
							    onChange={()=>{this.setState({recaptchaAllowed:true})}}
							    onErrored={()=>{this.setState({recaptchaAllowed:false})}}
							    onExpired={()=>{this.setState({recaptchaAllowed:false})}}
							  />
							  <div style={{textAlign:'center',margin:10}}>
								  {this.state.reloadingData ?
								  	'Please refresh website in a few minutes.'
									  :
									  null
									}
								</div>
							 <Button disabled={!this.state.recaptchaAllowed || this.state.reloadingData} onClick={()=>{this.props.reloadKingikData(); this.setState({reloadingData:true})}}>{'Send Reload Request'}</Button>
            </div>
          } trigger={
            <span style={{cursor:'pointer'}}>
							<Icon style={{color:'#a9a9a9',marginLeft:15}} name='redo' />
							<span style={{fontSize:'14px',color:'#9d9d9d',fontWeight:'400',lineHeight:'23px'}}>Reload Kingik Data</span>
            </span>
          } />
					</div>

				</div>

			</div>
		);
	}
}
export default Home;